import { UmbrellaLogo } from "@/components/UmbrellaLogo";

const SECTIONS = [
  ["1. What data we collect", [
    "Account details — your name, email address, profile photo, role (client or business) and, for businesses, company details such as trades, service areas, licence, insurance and registration information you provide.",
    "Jobs you post — the descriptions, budgets, locations, photos and other details of jobs created on the platform.",
    "Messages — the messages and attachments you send to other users through the platform.",
    "Payment information — payments and escrow are handled by Stripe. Card and banking details are collected and stored by Stripe, not by Black Umbrella. We receive only limited information such as payment status and payout eligibility needed to run the marketplace.",
  ]],
  ["2. How we use your data", [
    "We use your data to operate the marketplace: to create and manage your account, match jobs with relevant businesses, enable quoting and messaging, process escrow payments and payouts through Stripe, provide support, and keep the platform safe and secure.",
    "We may use contact details to send you service-related emails, such as job notifications, quote updates, and vetting or document-expiry reminders.",
  ]],
  ["3. How we share your data", [
    "We share information between clients and businesses only as needed to complete a job — for example, a client's job details are shared with businesses that can quote, and relevant contact information is shared once a quote is accepted.",
    "We share payment information with Stripe to process escrow payments and payouts, and with service providers that help us run the platform.",
  ]],
  ["4. We do not sell your data", [
    "Black Umbrella does not sell your personal data to third parties.",
  ]],
  ["5. Data security & retention", [
    "We take reasonable measures to protect your information and retain it for as long as your account is active or as needed to provide the service and meet legal obligations.",
  ]],
  ["6. Your choices", [
    "You can update your account details at any time and contact us to request access to, correction of, or deletion of your personal data, subject to legal and operational requirements.",
  ]],
];

export default function Privacy() {
  return (
    <div className="bg-white" data-testid="privacy-page">
      <section className="relative brand-grid-bg">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 pt-16 pb-8">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-amber-600 bg-amber-500/10 px-3 py-1.5 rounded-full">
            <UmbrellaLogo size={14} /> Legal
          </span>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-950 leading-[1.05]">
            Privacy Policy
          </h1>
          <p className="mt-4 text-slate-500">How Black Umbrella collects, uses and protects your data.</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-8 py-10 space-y-10">
        {SECTIONS.map(([title, paras]) => (
          <div key={title}>
            <h2 className="font-heading text-xl font-bold text-slate-950">{title}</h2>
            <div className="mt-3 space-y-3">
              {paras.map((p, i) => (
                <p key={i} className="text-slate-600 leading-relaxed">{p}</p>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
